import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.error.background,
  color: theme.palette.text.primary,
  padding: theme.spacing(1),
  lineHeight: theme.spacing(1.5),
  borderRadius: theme.spacing(0.5),
  marginTop: theme.spacing(1),
  gap: theme.spacing(1),
  '& .WBEsmallFontSize': {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.text.primary,
  },
  '& .WBEIcon': {
    display: 'flex',
    color: theme.palette.error.light,
    ' svg': {
      fontSize: theme.spacing(3)
    },
  },
  '& .WBECloseButton': {
    padding: 0,
    color: theme.palette.text.primary,
    ' svg': {
      fontSize: theme.spacing(2),
    },
  },
}));

export default StyledBox;